import { z } from "zod";

/**
 * «Не понимаю»: один бит от ученика преподавателю внутри занятия.
 *
 * Три ручки на этот бит: `GET /v1/lessons/:lessonId/signals` читает,
 * `POST /v1/lessons/:lessonId/signal` ставит, `DELETE` того же адреса снимает.
 * Преподаватель гасит чужую отметку по адресу участника,
 * `DELETE /v1/lessons/:lessonId/participants/:userId/signal`.
 *
 * ⚠️ **Почему это НЕ присутствие документа, в отличие от руки.** Рука живёт в
 * awareness, потому что обязана умирать вместе с соединением. Здесь другое: это
 * утверждение о трудностях КОНКРЕТНОГО ребёнка, и в общем присутствии оно
 * лежало бы в браузерах одиннадцати других детей (`docs/group-room-design.md`,
 * раздел 8). Поэтому строка в базе, и поэтому читатель у неё один.
 *
 * ⚠️ **Ученику видна только своя отметка.** Ответ у обеих сторон одной формы, но
 * ученику в нём приезжает не больше одной записи, его собственной, и правило это
 * стоит предикатом в `WHERE`, а не отбором на клиенте.
 */

/**
 * Кто из учеников комнаты отметил «не понимаю».
 *
 * ⚠️ **Список идентификаторов, а не строк с подписями.** Подпись каждого
 * участника у экрана уже есть, её привозит состав комнаты (`RoomRosterResponse`),
 * и второй канал имён означал бы второе правило подписи: в первый же день
 * профильное ФИО уехало бы этим каналом, раз уж каналом токена LiveKit оно
 * однажды уже уезжало.
 *
 * ⚠️ **Поле названо видом отметки, а не «signals», и это не мелочь.** Вид
 * отметки сегодня один (`stuck` в ключе таблицы), а завтра рядом встанет второй,
 * и тогда он приедет СВОИМ полем: старая вкладка его молча не заметит, а список
 * «не понимаю» у неё останется правдой. Общий список записей с полем вида
 * заставил бы старого читателя разбирать неизвестный ему вид, то есть ломающая
 * правка была бы там, где её никто не ждёт.
 *
 * ⚠️ **Ученик проверяет длину, а не ищет в списке себя.** Своего
 * идентификатора у него на экране нет вовсе, а ответ ему приезжает
 * отфильтрованным: непустой список и означает «я отметил».
 */
export const LessonSignalsResponse = z.object({
  stuck: z.array(z.string().uuid()),
});
export type LessonSignalsResponse = z.infer<typeof LessonSignalsResponse>;
